import $ from 'jquery';
import Cache from 'root/cache';
import UI from 'root/ui';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View_Video_Player from 'view/feedback_viewer/video_player';
import View_Details from 'view/feedback_sidebar/details';
import View from 'view/base';

export default View.extend({
    inbox_mode: false,
    screenshot_num: 0,

    views: {
        video_player: {},
        details: {}
    },

    events: {
        'click .item-header-collapsible'     : 'onToggleItem',
        'click .reporter-email-copy'         : 'onCopyReporterEmail',
        'click .reporter-details-edit'       : 'onEditReporterDetails',
        'click .region-media '               : 'onExpandToggle',
        'click .show-more'                   : 'onShowMore',
        'click .view-user'                   : 'onViewUser',
        'click .view-comments'               : 'onViewComments',
        'click .view-email-source a'         : 'onViewSource',
        'click .pin'                         : 'onClickPinComment',
        'click .session-replay-open'         : 'onOpenSessionReplay',
        'click .devtools-open'               : 'onOpenDevtools',
        'click .screenshot-prev'             : 'onViewPrevScreenshot',
        'click .screenshot-next'             : 'onViewNextScreenshot',
        'mouseenter .region-media'           : 'onPreviewScreenshotEnter',
        'mouseleave .region-media'           : 'onPreviewScreenshotLeave',
    },

    dom_handlers: {
        onToggleItem: function(e) {
            e.stopPropagation();
            $(e.currentTarget).parents('.session-item:first').toggleClass('open');
        },

        onCopyReporterEmail: function(e) {
            Util.copyText(this.model.get('email'), () => {
                UI.success('Reporter email copied to clipboard.');
            });
        },

        onEditReporterDetails: function(e) {
            Modals.editReporterDetails(this.model.id);
        },

        onPreviewScreenshotEnter: function(e) {
            this.dispatcher.trigger('Sidebar::Preview::Screenshot', true);
        },

        onPreviewScreenshotLeave: function(e) {
            this.dispatcher.trigger('Sidebar::Preview::Screenshot', false);
        },

        onExpandToggle: function(e) {
            if ($(e.target).hasClass('screenshot-prev') ||
                $(e.target).hasClass('screenshot-next') ||
                $(e.target).hasClass('pin') ||
                $(e.target).hasClass('local-screenshot-warning')) {
                return;
            }

            this.dispatcher.trigger('Sidebar::Expand::Screenshot');
        },

        onViewUser: function(e) {
            e.preventDefault();
            Modals.openUserIdentification(this.model.get('user_identification'));
        },

        onShowMore: function(e) {
            var description = Util.urlify(Util.nl2br(this.model.escape('description')));

            this.$el.find('.description-text').html(description);
        },

        onViewComments: function(e) {
            e.preventDefault();
            this.dispatcher.trigger('Sidebar::View::Comments');
        },

        onViewSource: function(e) {
            e.preventDefault();
            Modals.openFeedbackEmail(this.model.id);
        },

        onViewPrevScreenshot: function(e) {
            var screenshots = Cache.feedback_screenshot.where({feedback_id: this.model.id});
            var total = screenshots.length;

            if (this.screenshot_num === 0) {
                this.screenshot_num = total - 1;
            } else {
                this.screenshot_num--;
            }

            this.selectScreenshot();
        },

        onViewNextScreenshot: function(e) {
            var screenshots = Cache.feedback_screenshot.where({feedback_id: this.model.id});
            var total = screenshots.length;

            if (this.screenshot_num === total - 1) {
                this.screenshot_num = 0;
            } else {
                this.screenshot_num++;
            }

            this.selectScreenshot();
        },

        onClickPinComment: function(e) {
            this.dispatcher.trigger('Sidebar::View::Comments', $(e.currentTarget).data('id'));

            if (this.inbox_mode) {
                this.$el.find('.region-media .pin').removeClass('selected');
                $(e.currentTarget).addClass('selected');
            }
        },

        onOpenSessionReplay: function(e) {
            Modals.openSessionRecording(this.model.get('session_recording_id'), 0);
        },

        onOpenDevtools: function(e) {
            Modals.openDevtools(this.model);
        },
    },

    event_handlers: {
        onThreadSelect: function(view_cid, model_id) {
            if (!model_id) {
                // feedback description
                return;
            }

            // only inbox mode shows thumbnail and comments at the same time
            if (!this.inbox_mode) {
                return;
            }

            // select screenshot image in overview
            var screenshot_num = Cache.feedback_comment.get(model_id).get('screenshot_num');

            if (this.screenshot_num !== screenshot_num) {
                this.screenshot_num = screenshot_num;
                this.selectScreenshot();
            }

            // highlight pin comment
            this.$el.find('.region-media .pin').each((index, element) => {
                $(element).toggleClass('selected', $(element).data('id') === model_id);
            });
        },
    },

    initialize: function(options) {
        this.dispatcher = options.dispatcher;
        this.inbox_mode = !!options.inbox_mode;

        if (this.model.get('video_url')) {
            this.views.video_player = new View_Video_Player({
                model      : this.model,
                dispatcher : this.dispatcher,
                readonly   : true
            });
        }

        this.views.details = new View_Details({
            model: this.model,
            inbox_mode: this.inbox_mode
        });

        this.listenTo(Cache.user_identification, 'add remove', this.renderDescription);
        this.listenTo(this.model, 'change:email', this.renderDescription);
        this.listenTo(this.model, 'change:name', this.renderDescription);
        this.listenTo(Cache.feedback_comment, 'add remove', this.renderDescription);

        this.dispatcher.on('Thread:Select', this.event_handlers.onThreadSelect.bind(this));
    },

    getScreenshot: function() {
        return Cache.feedback_screenshot.where({feedback_id: this.model.id})[this.screenshot_num];
    },

    showSessionRecording: function() {
        if (Cache.real_user_id && !Cache.app.isClient()) {
            return true;
        }

        return false;
    },

    selectScreenshot: function() {
        this.$el.find('.screenshot img').attr('src', this.getScreenshot().get('url'));
        this.$el.find('.media-meta > span').text((this.screenshot_num + 1));

        this.renderPinComments();

        // fire event in the dispatcher to tell other views
        this.dispatcher.trigger('Sidebar::View::Screenshot', this.screenshot_num);

        // update hover preview
        this.$el.find('.region-media').mouseenter();
    },

    getUnsubscribedEmails: function () {
        var feedback_id = this.model.id;

        if (Cache.get('feedback_unsubscribed_emails') && Cache.get('feedback_unsubscribed_emails')[feedback_id]) {
            return Cache.get('feedback_unsubscribed_emails')[feedback_id];
        }

        return [];
    },

    getUnsubscribedStatus: function () {
        var unsubscribed_emails = this.getUnsubscribedEmails();
        var email = this.model.get('email');

        return unsubscribed_emails.includes(email);
    },

    renderDescription: function() {
        if (this.inbox_mode) {
            return;
        }

        var unsubscribed = this.getUnsubscribedStatus();
        var total_comments = this.model.getTotalComments();
        var identified_user = Cache.user_identification.findWhere({identification: this.model.get('user_identification')});

        var content =
        '<div class="description-heading">' +
            '<div class="flex-start">' +
                '<div class="user-img-32 margin-right-8" style="background-image:url(\'' + this.model.getReporterAvatar(24) + '\');"></div>' +
                '<div class="' + (this.model.escape('email') ? '' : 'flex-start') + '">' +
                    (identified_user ?
                    '<a href="#" class="view-user font-weight-medium no-underline tooltip" data-title="View identified user">' + Util.htmlEntities(this.model.getReporterName()) + ' <i class="fa-solid fa-square-arrow-up-right text-icon"></i></a>' :
                    '<div class="font-weight-medium">' + Util.htmlEntities(this.model.getReporterName()) + '</div>') +
                    '<div class="text-info">' +
                        (this.model.escape('email') ?
                        '<span class="reporter-email">' + this.model.escape('email') + '</span>' +
                        (unsubscribed ? '<i class="fad fa-bell-slash tooltip" data-title="Reporter has opted out of email updates"></i> ' : '') +
                        '<span class="reporter-email-copy"><i class="fa-solid fa-copy"></i></span>' : '') +
                        (Cache.app.isAdmin() || Cache.app.isCollaborator() ?
                        '<span class="reporter-details-edit tooltip" data-title="Edit Reporter Details"><i class="fa-solid fa-pen-to-square"></i></span>' : '') +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="date">' + Util.moment(this.model.get('time')) + '</div>' +
        '</div>' +

        '<div class="description-body">' +
            '<div class="description-text">' +
                (this.model.get('description').length <= 200 ?
                Util.urlify(Util.nl2br(this.model.escape('description'))) :

                Util.urlify(Util.nl2br(Util.htmlEntities(Util.trim(this.model.get('description'), 200, '')))) +
                ' <span style="white-space:nowrap;">... <a href="#" class="show-more text-primary no-underline font-weight-medium"> show more</a></span>') +
            '</div>' +

            (this.model.get('attachment') ?
            '<div class="attachment">' +
                Util.getFileIcon(this.model.get('attachment'), false) +
                '<a class=""href="' + this.model.get('attachment') + '" target="_blank" rel="noopener">' +
                    (Util.baseName(this.model.get('attachment')) === 'capture.webm' ? 'video recording' : Util.htmlEntities(Util.baseName(this.model.get('attachment')))) +
                '</a>' +
            '</div>' : '') +

            (this.model.get('load_type') === 'email' && Cache.real_user_id && !Cache.app.isClient() ?
            '<div class="view-email-source"><a href="#" class="primary font-weight-medium"><i class="fa-solid fa-envelope"></i> View Email</a></div>' : '') +
        '</div>' +

        '<a href="#" class="view-comments primary font-weight-medium">' + total_comments + ' comment' + (total_comments === 1 ? '' : 's') + '</a>';

        this.$('.region-description').html(content);
    },

    renderScreenshots: function() {
        var screenshots = Cache.feedback_screenshot.where({feedback_id: this.model.id});

        if (!screenshots.length) {
            return;
        }

        var thumbnails = '';
        screenshots.forEach((model, index) => {
            thumbnails += '<div' + (index === 0 ? ' class="active"' : '') + ' style="background-image:url(\'' + model.get('url') + '\');"></div>';
        });

        var content =
        '<div class="screenshot' + (this.model.get('is_auto_screenshot') ? ' screenshot-auto' : '') + '">' +
            (this.model.get('screenshot') && this.model.get('is_local') && this.model.get('load_type') === 'web' ?
            '<a class="local-screenshot-warning badge-warning-invert tooltip no-underline" data-title="Learn how to capture better screenshots" href="https://support.userback.io/en/articles/5209187" target="help" rel="noopener">' +
                'Broken screenshot?' +
            '</a>' : '') +
            '<img src="' + screenshots[0].get('url') + '">' +
            (screenshots.length > 1 ?
            '<div class="media-meta"><span>1</span> / ' + screenshots.length + '</div>' : '') +
        '</div>' +

        (screenshots.length > 1 ?
        '<button type="button" class="screenshot-prev"><i class="fa-solid fa-angle-left"></i></button>' +
        '<button type="button" class="screenshot-next"><i class="fa-solid fa-angle-right"></i></button>' : '');

        this.$('.region-media > div').html(content);

        this.renderPinComments();
    },

    renderPinComments: function() {
        this.$el.find('.pin').remove();

        var screenshot = this.getScreenshot();

        if (!screenshot) {
            return;
        }

        var image = new Image();
        image.onload = () => {
            Cache.feedback_comment.where({feedback_id: this.model.id, reply_comment_id: 0, screenshot_num: this.screenshot_num}).forEach((model) => {
                if (model.get('screen_number') > 0) {
                    this.renderPin(model, image);
                }
            });
        };
        image.src = this.getScreenshot().get('url');
    },

    renderPin: function(model, image) {
        var zoom     = this.$el.find('.screenshot img').width() / image.width;
        var offset_x = this.$el.find('.screenshot img').offset().left - this.$el.find('.screenshot').offset().left;
        var offset_y = this.$el.find('.screenshot img').offset().top  - this.$el.find('.screenshot').offset().top;

        $('<div>')
            .addClass('pin')
            .text(model.get('screen_number'))
            .css({
                top  : model.get('screen_y') * zoom + offset_y,
                left : model.get('screen_x') * zoom + offset_x
            })
            .data('id', model.id)
            .appendTo(this.$el.find('.screenshot'));
    },

    render: function() {
        var content =
        '<div class="region-media" data-type="' + (this.model.get('video_url') ? 'video' : 'screenshot') + '">' +
            (this.model.get('screenshot') ?
            '<span class="expand-icon"><i class="fa-solid fa-expand"></i></span>' : '') +
            '<div>' +
                (this.model.get('video_url') && this.model.get('video_length') ?
                '<div class="media-meta"><i class="fa-solid fa-play"></i>' + this.views.video_player.getDisplayTime(Math.round(this.model.get('video_length'))) + '</div>' : '') +
            '</div>' +
        '</div>' +


        (this.showSessionRecording() ?
        '<div class="region-media-btn-group">' +
            (this.model.get('session_recording_id') ?
            '<button type="button" class="session-replay-open"><i class="fa-solid fa-circle-play"></i>Session Replay</button>' :
            '<button type="button" class="disabled tooltip" data-title="No session replay captured"><i class="fa-solid fa-circle-play"></i>Session Replay</button>') +

            '' +
            '<button type="button" class="devtools-open"><i class="fa-solid fa-code"></i>Dev Tools</button>' +
        '</div>' : '') +

        (this.inbox_mode ? '' :
        '<div class="region-description"></div>') +
        '<hr class="small">' +
        (Cache.app.isClient() ? '' :
        '<div class="session-item open">' +
            '<div class="item-content region-details"></div>' +
        '</div>' +
        '<hr class="small">');

        this.$el.html(content);

        this.renderDescription();

        if (this.model.get('video_url')) {
            this.views.video_player.render().$el.appendTo(this.$('.region-media > div'));
        } else if (!this.model.get('screenshot')) {
            this.$('.region-media > div').html('<div class="screenshot screenshot-empty"></div>');
        } else {
            this.renderScreenshots();
        }

        if (!Cache.app.isClient()) {
            this.views.details.render().$el.prependTo(this.$('.region-details'));
        }

        return this;
    }
});